// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
import { HelpFragmentDoc } from "../../../ui/Help/gql/Fragment.generated";
import { OrganizationSelectFragmentDoc } from "../../../frame/PageSideNav/OrganizationSelect/gql/Fragment.generated";
import { PageUserNavFragmentDoc } from "../../../frame/PageUserNav/gql/Fragment.generated";
import { WarnIfServerOverageFragmentDoc } from "../../../frame/WarnIfServerOverage/gql/Fragment.generated";
import { WarnIfPastDueFragmentDoc } from "../../../frame/WarnIfPastDue/gql/Fragment.generated";
import { WarnIfSamlCertExpiringFragmentDoc } from "../../../frame/WarnIfSamlCertExpiring/gql/Fragment.generated";
import { OrganizationSetupFragmentDoc } from "../../../features/Setup/OrganizationSetup/gql/Fragment.generated";
import { PageAnalyticsFragmentDoc } from "../../../ui/PageAnalytics/gql/Fragment.generated";
import { PageHeaderNavFragmentDoc } from "../../../ui/PageHeaderNav/gql/Fragment.generated";
import { PageOnboardingNavFragmentDoc } from "../../../frame/PageOnboardingNav/gql/Fragment.generated";
import { WithSubscriptionCheckFragmentDoc } from "../../WithSubscriptionCheck/gql/Fragment.generated";
import { OrganizationFeaturesFragmentDoc } from "../../OrganizationFeatures/gql/Fragment.generated";
import { WithServerRetentionFragmentDoc } from "../../WithServerRetention/gql/Fragment.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type WithCurrentOrganizationQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type WithCurrentOrganizationQuery = {
  __typename?: "GraphqlQuery";
  getCurrentUserDetails: {
    __typename?: "User";
    id: string;
    email: string;
    demo: boolean;
    permittedToReviewChangelog: boolean;
    avatarUrl?: string | null;
    fullname?: string | null;
    organizations: Array<{
      __typename?: "Organization";
      id: string;
      slug: string;
      permittedToCreateWorkbooks: boolean;
      name: string;
      serverLimit?: number | null;
      serverCountForBilling: number;
      skipServerOverageWarning: boolean;
      pastDue: boolean;
      createdAt: number;
      permittedToCreateServers: boolean;
      enabledFeatures: {
        __typename?: "EnabledFeatures";
        id: string;
        indexCheck: boolean;
        checkUp: boolean;
        schemaStats: boolean;
        logs: boolean;
        activitySnapshots: boolean;
        saml: boolean;
        indexAdvisor: boolean;
        indexAdvisorV3Consolidation: boolean;
        lockMonitoring: boolean;
        querySearch: boolean;
        workbooks: boolean;
        queryAdvisor: boolean;
        hideWebsocketWarning: boolean;
        mcpServer: boolean;
        serverGroupCrud: boolean;
      };
      servers: Array<{
        __typename?: "Server";
        id: string;
        humanId: string;
        schemaProcessingDisabled: boolean;
        hasRecentSnapshot: boolean;
        createdAt: number;
        name: string;
        clusterId?: string | null;
        hasCriticalIssues: boolean;
        retentionInDays: number;
        latestStats?: {
          __typename?: "PostgresServerStats";
          isPrimary: boolean;
        } | null;
      }>;
      serverGroups: Array<{
        __typename?: "ServerGroup";
        id: string;
        name: string;
        description?: string | null;
        clusterId: string;
        permittedToEdit: boolean;
        primaryServerHumanId?: string | null;
        fallbackServerHumanId?: string | null;
        matchRules: Array<{
          __typename?: "ServerGroupMatchRule";
          id: string;
          matchType: Types.ServerGroupMatchTypeEnum;
          matchKey?: string | null;
          pattern: string;
        }>;
        servers: Array<{
          __typename?: "Server";
          id: string;
          humanId: string;
          schemaProcessingDisabled: boolean;
          hasRecentSnapshot: boolean;
          createdAt: number;
          name: string;
          clusterId?: string | null;
          hasCriticalIssues: boolean;
          retentionInDays: number;
          latestStats?: {
            __typename?: "PostgresServerStats";
            isPrimary: boolean;
          } | null;
        }>;
      }>;
      customServerGroups: Array<{
        __typename?: "ServerGroup";
        id: string;
        name: string;
        description?: string | null;
        permittedToEdit: boolean;
        permittedToDelete: boolean;
        fallbackServerHumanId?: string | null;
        matchRules: Array<{
          __typename?: "ServerGroupMatchRule";
          id: string;
          matchType: Types.ServerGroupMatchTypeEnum;
          matchKey?: string | null;
          pattern: string;
        }>;
      }>;
      samlIntegration?: {
        __typename?: "SamlIntegration";
        id: string;
        idpCertExpiresAt?: number | null;
      } | null;
      onboardingProgress: {
        __typename?: "OrganizationOnboardingProgress";
        id: string;
        hasDatabasesIntegrated: boolean;
        hasRecentData: boolean;
        integratedCollector: boolean;
        integratedLogInsights: boolean;
        integratedExplain: boolean;
        integratedEmailAlerts: boolean;
        lastIntegratedServer?: {
          __typename?: "Server";
          id: string;
          humanId: string;
        } | null;
      };
      planInfo: {
        __typename?: "OrganizationPlanInfo";
        id: string;
        subscriptionPlanId: string;
        activeSubscription: boolean;
        trialEndsAt?: number | null;
        isTrial: boolean;
      };
    }>;
  };
};

export const WithCurrentOrganizationDocument = gql`
  query WithCurrentOrganization {
    getCurrentUserDetails {
      id
      email
      ...Help
      ...OrganizationSelect
      ...PageUserNav
      organizations {
        id
        slug
        permittedToCreateWorkbooks
        ...WarnIfServerOverage
        ...WarnIfPastDue
        ...WarnIfSamlCertExpiring
        ...OrganizationSetup
        ...PageAnalytics
        ...PageHeaderNav
        ...PageOnboardingNav
        ...WithSubscriptionCheck
        enabledFeatures {
          ...OrganizationFeatures
        }
        servers(standalone: true) {
          id
          humanId
          schemaProcessingDisabled
          hasRecentSnapshot
          latestStats {
            isPrimary
          }
          createdAt
          ...WithServerRetention
        }
        serverGroups {
          id
          name
          description
          clusterId
          permittedToEdit
          matchRules {
            id
            matchType
            matchKey
            pattern
          }
          servers {
            id
            humanId
            schemaProcessingDisabled
            hasRecentSnapshot
            hasCriticalIssues
            latestStats {
              isPrimary
            }
            createdAt
            ...WithServerRetention
          }
        }
        customServerGroups {
          id
          name
          description
          permittedToEdit
          permittedToDelete
          matchRules {
            id
            matchType
            matchKey
            pattern
          }
        }
      }
    }
  }
  ${HelpFragmentDoc}
  ${OrganizationSelectFragmentDoc}
  ${PageUserNavFragmentDoc}
  ${WarnIfServerOverageFragmentDoc}
  ${WarnIfPastDueFragmentDoc}
  ${WarnIfSamlCertExpiringFragmentDoc}
  ${OrganizationSetupFragmentDoc}
  ${PageAnalyticsFragmentDoc}
  ${PageHeaderNavFragmentDoc}
  ${PageOnboardingNavFragmentDoc}
  ${WithSubscriptionCheckFragmentDoc}
  ${OrganizationFeaturesFragmentDoc}
  ${WithServerRetentionFragmentDoc}
`;

/**
 * __useWithCurrentOrganizationQuery__
 *
 * To run a query within a React component, call `useWithCurrentOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useWithCurrentOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWithCurrentOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useWithCurrentOrganizationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    WithCurrentOrganizationQuery,
    WithCurrentOrganizationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WithCurrentOrganizationQuery,
    WithCurrentOrganizationQueryVariables
  >(WithCurrentOrganizationDocument, options);
}
export function useWithCurrentOrganizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WithCurrentOrganizationQuery,
    WithCurrentOrganizationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WithCurrentOrganizationQuery,
    WithCurrentOrganizationQueryVariables
  >(WithCurrentOrganizationDocument, options);
}
// @ts-ignore
export function useWithCurrentOrganizationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WithCurrentOrganizationQuery,
    WithCurrentOrganizationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WithCurrentOrganizationQuery,
  WithCurrentOrganizationQueryVariables
>;
export function useWithCurrentOrganizationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WithCurrentOrganizationQuery,
        WithCurrentOrganizationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WithCurrentOrganizationQuery | undefined,
  WithCurrentOrganizationQueryVariables
>;
export function useWithCurrentOrganizationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WithCurrentOrganizationQuery,
        WithCurrentOrganizationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WithCurrentOrganizationQuery,
    WithCurrentOrganizationQueryVariables
  >(WithCurrentOrganizationDocument, options);
}
export type WithCurrentOrganizationQueryHookResult = ReturnType<
  typeof useWithCurrentOrganizationQuery
>;
export type WithCurrentOrganizationLazyQueryHookResult = ReturnType<
  typeof useWithCurrentOrganizationLazyQuery
>;
export type WithCurrentOrganizationSuspenseQueryHookResult = ReturnType<
  typeof useWithCurrentOrganizationSuspenseQuery
>;
export type WithCurrentOrganizationQueryResult = Apollo.QueryResult<
  WithCurrentOrganizationQuery,
  WithCurrentOrganizationQueryVariables
>;
